import Model from './model'
import { BACKEND_URL } from '../config'

class TrackedGeolocation extends Model {
  static get name() {
    return 'locations'
  }

  static get url() {
    return `${BACKEND_URL}/tracking/positions`
  }

  get coordinates() {
    return {
      longitude: this.longitude,
      latitude: this.latitude
    }
  }
  set coordinates(data) {
    this.longitude = data.longitude
    this.latitude = data.latitude
  }
}

export default TrackedGeolocation
